import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'psc-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

  appVersion = environment.version;

  socialMedia = [
    { icon: 'facebook', alt: 'Facebook', link: 'https://www.facebook.com/pvsmartclick' },
    { icon: 'instagram', alt: 'Instagram', link: 'https://www.instagram.com/pvsmartclick/' },
    { icon: 'twitter', alt: 'Twitter', link: 'https://twitter.com/pvsmartclick' },
    { icon: 'linkedin', alt: 'LinkedIn', link: 'https://www.linkedin.com/in/pvsmartclick-by-digital-arena-87b0a5285/' },
  ];

  companyInfo = {
    name: 'Digital Arena d.o.o',
    address: 'Zagreb, XI Podbrežje 11a',
    oib: 'OIB: 69476362249'
  };

  contactInfo = {
    email: 'pvsmartclick@digitalarena.hr',
    phone1: '+385 91 665 1801',
    phone2: '+387 63 426 306'
  };
}
